import {InjectionToken} from "@angular/core";
import {TIntStorageType} from "../../types";

export const INT_STORAGE_TYPE_TOKEN = new InjectionToken<TIntStorageType>('INT_STORAGE_TYPE_TOKEN', {
  factory: () => {
    return "localStorage";
  },
  providedIn: 'root'
})
